import { createConversationMachine, runConversationMachineSelfTest, VOICE_STATES } from './conversationMachine';
import { createOrderedChunkBuffer } from './orderedChunkBuffer';
import { createSseParser } from './sseParser';
import { calculateAdaptiveTurnDecision } from './adaptiveTurnDetector';

export const runVoiceSelfTests = () => {
  const results = [];
  results.push({ name: 'legal state transitions and illegal rejection', passed: runConversationMachineSelfTest() });

  const stressMachine = createConversationMachine({ conversationId: 'fifty-turn-stress' });
  const turnStates = [
    VOICE_STATES.REQUEST_MICROPHONE, VOICE_STATES.MICROPHONE_READY, VOICE_STATES.LISTENING,
    VOICE_STATES.VOICE_DETECTED, VOICE_STATES.RECORDING, VOICE_STATES.PROCESSING_AUDIO,
    VOICE_STATES.WAITING_FOR_STT, VOICE_STATES.WAITING_FOR_LLM, VOICE_STATES.GENERATING_TTS,
    VOICE_STATES.PLAYING_AUDIO, VOICE_STATES.WAITING_FOR_USER,
  ];
  let fiftyTurnsPassed = true;
  for (let turn = 0; turn < 50; turn += 1) {
    fiftyTurnsPassed = Boolean(stressMachine.beginTurn()) && turnStates.every((state) => stressMachine.transition(state));
    if (!fiftyTurnsPassed) break;
  }
  const stressSnapshot = stressMachine.getSnapshot();
  results.push({ name: '50 consecutive deterministic turns', passed: fiftyTurnsPassed && stressSnapshot.turnNumber === 50 && stressSnapshot.state === VOICE_STATES.WAITING_FOR_USER && stressSnapshot.timeline.length <= 300 });

  const ordered = [];
  const buffer = createOrderedChunkBuffer({ onReady: (chunk) => ordered.push(chunk.sequence) });
  buffer.reset('turn-1');
  buffer.add({ turnId: 'turn-1', sequence: 2 });
  buffer.add({ turnId: 'turn-1', sequence: 0 });
  buffer.add({ turnId: 'turn-1', sequence: 1 });
  results.push({ name: 'out-of-order TTS buffering', passed: ordered.join(',') === '0,1,2' });

  const fiftyOrdered = [];
  const stressBuffer = createOrderedChunkBuffer({ onReady: (chunk) => fiftyOrdered.push(chunk.sequence) });
  stressBuffer.reset('turn-50');
  for (let sequence = 49; sequence >= 0; sequence -= 1) stressBuffer.add({ turnId: 'turn-50', sequence });
  results.push({ name: '50 out-of-order chunks play sequentially', passed: fiftyOrdered.every((sequence, index) => sequence === index) });

  const events = [];
  const parser = createSseParser((event) => events.push(event));
  const payload = 'data: {"event":"token","token":"Complete sentence.","sequence":1}\n\ndata: {"event":"complete","done":true}\n\n';
  parser.push(payload.slice(0, 13));
  parser.push(payload.slice(13, 49));
  parser.push(payload.slice(49));
  parser.flush();
  results.push({ name: 'fragmented SSE buffering', passed: events.length === 2 && events[0].sequence === 1 && events[1].done === true });
  const patientPause = calculateAdaptiveTurnDecision({
    activeSpeechMs: 4000,
    elapsedMs: 7000,
    silenceMs: 1000,
    burstCount: 3,
    resumedPauses: [800, 950],
    recentVoiceEnergy: 0.05,
    currentEnergy: 0.001,
    semanticHint: { status: 'incomplete', confidence: 0.9 },
    probePending: false,
  });
  results.push({ name: 'adaptive detector preserves natural pauses', passed: !patientPause.shouldEnd && patientPause.thresholdMs >= 1800 });
  return { passed: results.every((result) => result.passed), results };
};
